module.exports = __webpack_public_path__ + "static/media/brand-walmart.8da624be.png";